import React from 'react'
import clsx from 'clsx'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  isLoading?: boolean
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', isLoading, disabled, children, ...props }, ref) => {
    const baseStyles = 'inline-flex items-center justify-center font-medium rounded-lg transition border'

    const variantStyles = {
      primary: 'border-slate-700 bg-slate-700 text-stone-100 hover:bg-slate-800 disabled:border-slate-400 disabled:bg-slate-400',
      secondary: 'border-stone-400 bg-stone-200 text-slate-900 hover:bg-stone-100 disabled:border-stone-300 disabled:bg-stone-200',
      danger: 'border-red-700 bg-red-700 text-red-50 hover:bg-red-800 disabled:border-red-300 disabled:bg-red-300',
      ghost: 'border-stone-400 bg-stone-100 text-slate-800 hover:bg-stone-50 disabled:text-stone-500',
    }

    const sizeStyles = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-base',
      lg: 'px-6 py-3 text-lg',
    }

    return (
      <button
        ref={ref}
        disabled={disabled || isLoading}
        className={clsx(baseStyles, variantStyles[variant], sizeStyles[size], className)}
        {...props}
      >
        {isLoading && <span className="spinner mr-2 h-4 w-4" />}
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'
